import {useGetTenantSettings} from 'hooks/useTenant';
import {ItemDataFieldModel} from 'models/board';
import {TenantSettingsControlTypeKeysEnum} from 'models/settings';
import React, {useEffect} from 'react';
import {RenderSelect} from '.';
import {FieldsRendererProps} from '../FieldsRenderer';

interface RenderIntegrationSelectProps extends FieldsRendererProps {
    gridSize?: number;
}

export const RenderIntegrationSelect: React.FC<RenderIntegrationSelectProps> = props => {
    const [updatedField, setUpdatedField] = React.useState<ItemDataFieldModel | undefined>(undefined);
    const {field} = props;
    const {getTenanatSettings, getTenanatSettingsLoading, getTenanatSettingsRespones} = useGetTenantSettings();
    useEffect(() => {
        getTenanatSettings({
            variables: {
                controlType: TenantSettingsControlTypeKeysEnum.Integration,
            },
        });
    }, []);

    useEffect(() => {
        if (getTenanatSettingsRespones && getTenanatSettingsRespones.length > 0) {
            const options = getTenanatSettingsRespones.map(setting => {
                const shouldUseAsTheField = setting.data?.find(x => x.shouldUseAsTheFieldToCreateItem);
                return {
                    label: shouldUseAsTheField?.value.value ?? '',
                    value: setting.id,
                };
            });
            console.log('options', options);

            setUpdatedField({
                ...field,
                defaultValue: {options: options.filter(option => option.label !== '')},
            });
        }
    }, [getTenanatSettingsRespones, field]);

    if (!updatedField) {
        return <></>;
    }
    return <RenderSelect {...props} isLoading={getTenanatSettingsLoading} field={updatedField} />;
};
export default RenderIntegrationSelect;
